import { Helmet } from 'react-helmet';
import { useCurrentApp } from 'hooks/useCurrentApp';
import { useMemo } from 'react';
import { IS_ETE, IS_LOCAL, IS_QA } from 'constants/envConstants';

interface PageTitleProps {
  customTitle?: string;
}

const PageTitle = ({ customTitle }: PageTitleProps) => {
  const { currentApp, currentView } = useCurrentApp();

  const title = useMemo(() => {
    if (customTitle) {
      return `Cofactr: ${customTitle}`;
    }

    if (currentApp?.name === 'Dashboard') {
      return 'Cofactr';
    }
    if (currentApp?.name === 'Error') {
      return 'Cofactr: Page Not Found';
    }

    // If we have a view, show both app and view
    if (
      !!currentView?.name &&
      !!currentApp?.name &&
      currentView.name !== currentApp.name
    ) {
      return `Cofactr: ${currentApp.name} - ${currentView.name}`;
    }

    if (currentView?.name) {
      return `Cofactr: ${currentView.name}`;
    }

    if (currentApp?.name) {
      return `Cofactr: ${currentApp.name}`;
    }

    return 'Cofactr';
  }, [currentApp, currentView, customTitle]);

  return (
    <Helmet>
      <title>
        {IS_LOCAL ? '🔧' : IS_ETE || IS_QA ? '🧪' : ''}
        {title}
      </title>
    </Helmet>
  );
};

export default PageTitle;
